// removed by extract-text-webpack-plugin
module.exports = {"container":"_3LcXoU01871MDO2E2Uw5H2","question":"_2pWBLs9Zf8YPawVIxflJez","answerContainer":"_3Ir6Ll_lhB_-Mw48TNtQYw","bottomContainer":"J2FxJhtt-eWfWtqz-UrBy","button":"jvIQxTn-jafLpEBjuUgs-","tag":"_2A82wQy4kM77ZQI7EBgA4V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Question/styles.css
// module id = 385
// module chunks = 0